import { render, staticRenderFns } from "./CardRole.vue?vue&type=template&id=a67d7e6a"
import script from "./CardRole.vue?vue&type=script&lang=js"
export * from "./CardRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports